export default "__VITE_ASSET__35c6650b__"